import React from 'react'
import PropTypes from 'prop-types'

import TopHeaderRow from './TopHeaderRow'
import ModelSupportConversationTitle from './ModelSupportConversationTitle'
import FeedbackConversationTitle from './FeedbackConversationTitle'

const Header = ({
  archived, reported, type, onMoveToArchiveSuccess, onReportSuccess, typeData, conversationId, recipient,
}) => {
  const TitleElement = (() => {
    switch (type) {
      case 'personal':
        return <div>{typeData.subject}</div>
      case 'cgtrader_support':
        return <div>{typeData.subject}</div>
      case 'model_support':
        return <ModelSupportConversationTitle itemUrl={typeData.itemUrl} itemTitle={typeData.itemTitle} />
      case 'model_feedback':
        return <FeedbackConversationTitle title={typeData.title} itemUrl={typeData.itemUrl} itemTitle={typeData.itemTitle} />
    }
  })()

  return (
    <div>
      <div className="conversation__header">
        <TopHeaderRow
          archived={archived}
          reported={reported}
          titleElement={TitleElement}
          onMoveToArchiveSuccess={onMoveToArchiveSuccess}
          conversationId={conversationId}
          onReportSuccess={onReportSuccess}
          recipient={recipient}
        />
      </div>
    </div>
  )
}

Header.propTypes = {
  onMoveToArchiveSuccess: PropTypes.func.isRequired,
  onReportSuccess: PropTypes.func.isRequired,
  typeData: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  conversationId: PropTypes.string.isRequired,
  archived: PropTypes.bool,
  reported: PropTypes.bool,
  recipient: PropTypes.string.isRequired,
}

TopHeaderRow.defaultPropTypes = {
  archived: false,
  reported: false,
}

export default Header
